import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OpusAgentChatListItemFragment = { __typename?: 'OpusAgentChat', model?: Types.OpusAgentModel | null, id: string, title?: string | null, titleSource?: Types.OpusAgentChatTitleSource | null, lastActivity?: string | null, createdAt: string };

export type OpusAgentChatsQueryVariables = Types.Exact<{
  input: Types.OpusAgentChatsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type OpusAgentChatsQuery = { __typename?: 'Query', OpusAgentChats: { __typename?: 'OpusAgentChats', totalCount?: number | null, objects: Array<{ __typename?: 'OpusAgentChat', model?: Types.OpusAgentModel | null, id: string, title?: string | null, titleSource?: Types.OpusAgentChatTitleSource | null, lastActivity?: string | null, createdAt: string }> } };

export type RenameOpusAgentChatMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  title: Types.Scalars['String']['input'];
}>;


export type RenameOpusAgentChatMutation = { __typename?: 'Mutation', renameOpusAgentChat: { __typename?: 'RenameOpusAgentChatResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, chat?: { __typename?: 'OpusAgentChat', model?: Types.OpusAgentModel | null, id: string, title?: string | null, titleSource?: Types.OpusAgentChatTitleSource | null, lastActivity?: string | null, createdAt: string } | null } };

export const OpusAgentChatListItemFragmentDoc = gql`
    fragment OpusAgentChatListItem on OpusAgentChat {
  model
  id
  title
  titleSource
  lastActivity
  createdAt
}
    `;
export const OpusAgentChatsDocument = gql`
    query OpusAgentChats($input: OpusAgentChatsInput!, $pagination: PaginationInput) {
  OpusAgentChats(input: $input, pagination: $pagination) {
    objects {
      ...OpusAgentChatListItem
    }
    totalCount
  }
}
    ${OpusAgentChatListItemFragmentDoc}`;

/**
 * __useOpusAgentChatsQuery__
 *
 * To run a query within a React component, call `useOpusAgentChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpusAgentChatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useOpusAgentChatsQuery(baseOptions: Apollo.QueryHookOptions<OpusAgentChatsQuery, OpusAgentChatsQueryVariables> & ({ variables: OpusAgentChatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpusAgentChatsQuery, OpusAgentChatsQueryVariables>(OpusAgentChatsDocument, options);
      }
export function useOpusAgentChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpusAgentChatsQuery, OpusAgentChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpusAgentChatsQuery, OpusAgentChatsQueryVariables>(OpusAgentChatsDocument, options);
        }
export type OpusAgentChatsQueryHookResult = ReturnType<typeof useOpusAgentChatsQuery>;
export type OpusAgentChatsLazyQueryHookResult = ReturnType<typeof useOpusAgentChatsLazyQuery>;
export type OpusAgentChatsQueryResult = Apollo.QueryResult<OpusAgentChatsQuery, OpusAgentChatsQueryVariables>;
export const RenameOpusAgentChatDocument = gql`
    mutation RenameOpusAgentChat($id: UUID!, $title: String!) {
  renameOpusAgentChat(id: $id, title: $title) {
    success
    error {
      code
      message
    }
    chat {
      ...OpusAgentChatListItem
    }
  }
}
    ${OpusAgentChatListItemFragmentDoc}`;
export type RenameOpusAgentChatMutationFn = Apollo.MutationFunction<RenameOpusAgentChatMutation, RenameOpusAgentChatMutationVariables>;

/**
 * __useRenameOpusAgentChatMutation__
 *
 * To run a mutation, you first call `useRenameOpusAgentChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameOpusAgentChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameOpusAgentChatMutation, { data, loading, error }] = useRenameOpusAgentChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useRenameOpusAgentChatMutation(baseOptions?: Apollo.MutationHookOptions<RenameOpusAgentChatMutation, RenameOpusAgentChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameOpusAgentChatMutation, RenameOpusAgentChatMutationVariables>(RenameOpusAgentChatDocument, options);
      }
export type RenameOpusAgentChatMutationHookResult = ReturnType<typeof useRenameOpusAgentChatMutation>;
export type RenameOpusAgentChatMutationResult = Apollo.MutationResult<RenameOpusAgentChatMutation>;
export type RenameOpusAgentChatMutationOptions = Apollo.BaseMutationOptions<RenameOpusAgentChatMutation, RenameOpusAgentChatMutationVariables>;